import React from "react";



import { Box } from "components/basic-components";



import styles from "./InfoDivider.module.scss";
import { BoxProps } from "@mui/material";


export const InfoDivider = ({sx}: {sx?: BoxProps['sx']}) => {
  return (
    <Box sx={sx} className={styles.dividerSymbol}>
      •
    </Box>
  );
};